import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CloseButton = ({ onClick }) => (
  <button
    className={classNames(
      'border-0 w-9 h-9 block rounded-full bg-white absolute cursor-pointer text-center top-[calc(130px+var(--visible-promotion-banner-height))] right-2.5',
      'md:top-[11.5rem] md:right-4',
      'hover:before:rotate-45 hover:before:scale-125',
      'hover:after:-rotate-45 hover:after:-scale-125',
      "before:content-[''] before:absolute before:w-[15px] before:h-0.5 before:bg-gray-light1 before:rounded-sm before:top-1/2 before:transition-all before:duration-300 before:rotate-45 before:left-1/2 before:-ml-[7.5px] before:-mt-px",
      "after:content-[''] after:absolute after:w-[15px] after:h-0.5 after:bg-gray-light1 after:rounded-sm after:top-1/2 after:transition-all after:duration-300 after:-rotate-45 after:right-1/2 after:-mr-[7.5px] after:-mt-px"
    )}
    aria-label="Close (Return to Blog page)"
    type="button"
    onClick={onClick}
  />
);

CloseButton.propTypes = {
  onClick: PropTypes.func,
};

export default CloseButton;
